import OffDays from '@/views/offdays/OffDays'

export default [
  {
    path: 'bloqueo-dias',
    name: 'offdays.index',
    component: OffDays
  }
]
